import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-check-check-icon lucide-check-check",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M18 6 7 17l-5-5" }), /* @__PURE__ */ _jsx("path", { d: "m22 10-7.5 7.5L13 16" })]
});
export { SvgCheckCheck as ReactComponent };
